export default "__VITE_ASSET__DrSbNERf__"